<template>
    <div class="bg-white rounded box-shadow p-3 mb-1" style="padding-bottom:1px !important">
        <div class="row">
            <div v-if="show" class="alert alert-danger alert-dismissible fade show" role="alert">
                <span v-for="(err, index) in validation_errors" :key="index">
                  {{ err[0] }} <br />
                </span>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <h5 class="float-left">Existing crop in the affected land</h5>
            </div>
            <div class="col">
                <b-button v-b-modal.crop-modal type="button"
                          @click="resetForm(),$bvModal.show('crop-modal')"
                          class="btn btn-success float-right btn-sm mb-1 text-black float-right">
                    Add Affected Crop
                    <i class="fas fa-plus"></i>
                </b-button>
            </div>
        </div>

        <div class="scrollable-table">
            <table class="table table-centered table-striped">
                <thead>
                <tr>
                    <th>SL</th>
                    <th>Land Info</th>
                    <th>Land Cultivation</th>
                    <th>Existing crops in the field</th>
                    <th>Khatian No.</th>
                    <th>Cultivated affected land (decimal)</th>
                    <th>Production (Kg)</th>
                    <th>Present Market Value (Tk.)</th>
                    <th>CCL No. </th>
                    <th>CCL Amount</th>
                    <th>Amounts</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(crop_affected, index) in crop_affecteds" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>Land id: {{ crop_affected.land.id }}, Mouza: {{ crop_affected.land.mouza.mouza_desc }}, Plot: {{ crop_affected.land.plot_no }}</td>
                    <td>{{ crop_affected.land_cultivation.land_cultivation_desc }}</td>
                    <td>{{ crop_affected.crop_category.crop_category_desc }}</td>
                    <td>{{ crop_affected.khatian_num }}</td>
                    <td>{{ crop_affected.cultivated_land }}</td>
                    <td>{{ crop_affected.production }}</td>
                    <td>{{ crop_affected.market_value }}</td>
                    <td><span v-if="crop_affected.ccl_crop">{{ crop_affected.ccl_crop.ccl ? crop_affected.ccl_crop.ccl.ccl_no : ''}}</span></td>
                  <td>{{ crop_affected.ccl_crop ? crop_affected.ccl_crop.ccl_amount : ''}}</td>
                  <td>{{crop_affected.amounts}}</td>
                  <td>
                      <b-button variant="info"
                                class="btn btn-info btn-xs waves-effect waves-light  mr-2"
                                @click.prevent="viewCrop(crop_affected)">
                        <i class="mdi mdi-account-card-details"></i>
                      </b-button>
                      <b-button  variant="warning" class="btn btn-warning btn-xs waves-effect waves-light  mr-2" @click.prevent="getStructure(crop_affected), $bvModal.show('crop-modal')"><i class="far fa-edit"></i></b-button>
                      <b-button variant="danger" class="btn btn-warning btn-xs waves-effect waves-light" @click.prevent="softDelete(crop_affected.id)"><i class="far fa-trash-alt"></i></b-button>
                    </td>
                </tr>
                </tbody>
            </table>
            <h5 v-if="crop_affecteds.length === 0" class="text-center text-secondary">
                No Data Found
            </h5>
        </div>

        <crop-modal
                :crop_affected="crop_affected"
                :btn_edit="btn_edit"
                :cclShow="cclShow"
                @cclShowUpdate="cclShowUpdate"
                @getPersonAffectedCrop="getPersonAffectedCrop"
                @resetForm="resetForm"
        ></crop-modal>
      <crop-modal-view
          :affected_crop_list="affected_crop_list"
          @getPersonAffectedCrop="getPersonAffectedCrop">
      </crop-modal-view>
    </div>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    import CropModal from "../../modals/CropModal";
    import CropModalView from "../../modals/CropModalView";

    export default {
        page: {
            title: "Search Affected Crop",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader, CropModal, CropModalView},
        data() {
            return {
                title: "Search Affected Crop",
                items: [
                    {
                        text: 'Dashboard',
                        href: '/',
                    },
                    {
                        text: 'Search',
                        active: true,
                    },
                ],
                crop_affecteds: {},
                crop_affected: {},
                btn_edit: false,
                validation_errors: {},
                affected_crop_list: {},
                show: false,
                cclShow: false,
            };
        },

        mounted() {
            this.crop_affected.ses_id = this.$route.params.ses_id;
            this.getPersonAffectedCrop();
        },

        methods: {
            getStructure(crop_affected) {
                this.crop_affected = {};
                this.btn_edit = true;
                http.get("api/crops/" + crop_affected.id + "/edit").then(response => {
                    if (!response.error) {
                        this.crop_affected = response.data.crop_affected;
                        this.crop_affected.land_ownership_type_id == 1
                            ? (this.cclShow = true)
                            : (this.cclShow = false);

                      this.$children[0].getCclCrop(this.crop_affected.land_id);
                      this.$children[0].getCclInfo(this.crop_affected.ccl_id);
                    }
                });
            },
            softDelete(crop_id) {
                if (confirm("Do you really want to delete?")) {
                    http.delete("api/crops/" + crop_id).then(response => {
                        if (!response.error) {
                            if(response.data.error === true){
                                this.$bvToast.toast(response.data.message, {
                                    title: "Error",
                                    autoHideDelay: 5000,
                                    variant: "danger"
                                });
                            }else{
                                this.$bvToast.toast(response.data.message, {
                                    title: "Success",
                                    autoHideDelay: 5000,
                                    variant: "success"
                                });
                                this.getPersonAffectedCrop();
                            }

                        } else {
                            this.$bvToast.toast("Deleted Failed", {
                                title: "Error",
                                autoHideDelay: 5000,
                                variant: "danger"
                            });
                        }
                    });
                }
            },
            getPersonAffectedCrop() {
                http.get("api/getPersonCropAffected/" + this.crop_affected.ses_id)
                    .then(response => {
                        if (!response.error) {
                            this.crop_affecteds = response.data.crop_affecteds;
                        }
                    });
            },
            cclShowUpdate(value) {
              this.cclShow = value;
            },
            resetForm() {
                this.btn_edit = false;
                this.cclShow = false;
                this.crop_affected = {};
                this.crop_affected.ses_id = this.$route.params.ses_id;
                this.crop_affected.land_id = "";
                this.crop_affected.crop_category_id = "";
                this.$children[0].getCodes()
            },
            viewCrop(affected_crop_list){
              this.affected_crop_list = {};
              this.affected_crop_list = affected_crop_list;
              this.$root.$emit("bv::show::modal", "crop-modal-view");
            },
        },
    };
</script>


<style lang="scss">

</style>
